export enum PRODUCT_PERMISSIONS {
  PRODUCT_VIEW = 'PRODUCT_VIEW',
  PRODUCT_WRITE = 'PRODUCT_WRITE',
  PRODUCT_PRICE = 'PRODUCT_PRICE',
  PRODUCT_ANALYTICS = 'PRODUCT_ANALYTICS',
  PRODUCT_VARIANTS = 'PRODUCT_VARIANTS',
  REPLENISHMENT_WRITE = 'REPLENISHMENT_WRITE',
}

export enum PRODUCT_OFFER_PERMISSIONS {
  PRODUCT_OFFER_VIEW = 'OFFER_PRODUCTVIEW',
  PRODUCT_OFFER_WRITE = 'OFFER_PRODUCTWRITE',
}
